import React, { useState } from "react";
import axios from "axios";
import Signup from "./Signup";
import "./LoginPopup.css";
import socket from '../../utils/socket';
import { GoogleLogin } from '@react-oauth/google';

const LoginPopup = ({ onClose }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showSignup, setShowSignup] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMessage("");

    try {
      const response = await axios.post(
        "https://back.varankal.com/auth/login",
        { email, password },
        { withCredentials: true }
      );

      if (response.status === 200) {
        const { token, user, profileStep } = response.data;

        // Save all login values
        localStorage.setItem("token", token);
        localStorage.setItem("user", JSON.stringify(user));
        localStorage.setItem("profileStep", response.data.profileStep);
        localStorage.removeItem("hideProfileModal"); // allow modal again


        // socket join
        socket.emit("join", user._id);
        socket.connect();

        onClose();

        // Go to dashboard or matchlist as you want
        window.location.href = "/matchlist";
      }
    } catch (error) {
      console.error("Error:", error);
      setErrorMessage(
        error.response?.data?.message || "An error occurred. Please try again."
      );
    }
  };

  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      if (!credentialResponse?.credential) {
        setErrorMessage("Google login failed");
        return;
      }

      const res = await axios.post(
        "https://back.varankal.com/auth/google-login",
        { idToken: credentialResponse.credential },
        { withCredentials: true }
      );

      const { token, user, profileStep } = res.data;

      // Store login data
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("profileStep", profileStep);
      localStorage.removeItem("hideProfileModal");

      // Socket join
      socket.connect();
      socket.on("connect", () => {
        socket.emit("join", user._id);
      });

      // Redirect
      window.location.href = "/matchlist";

    } catch (error) {
      console.error("Google login failed:", error.response?.data || error);
      setErrorMessage(
        error.response?.data?.message ||
        "This Google account is not registered. Please sign up first."
      );
    }
  };


  return (
    <>
      {!showSignup && (
        <div className="popup-overlay9090">
          <div className="popup-container9090">

            <div className="logo-container9090">
              <img
                src="/Images/icon tm.png"
                alt="Varankal Logo"
                className="logo9090"
              />
            </div>

            <button className="close-btn9090" onClick={onClose}>
              ✖
            </button>

            <h3 className="login-heading9090">Log in to Your Account</h3>

            {errorMessage && <p className="error-message">{errorMessage}</p>}

            <form onSubmit={handleLogin}>
              <div className="input-group9090">
                <label>Email:</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className="input-group9090">
                <label>Password:</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <a href="/forgetpassword1" className="forgot-passworddd89">
                  Forgot Password?
                </a>
              </div>

              <button className="button37799" type="submit">
                Login
              </button>
            </form>
            <div className="google-divider9090">
              <span>OR</span>
            </div>



            <GoogleLogin
              onSuccess={handleGoogleSuccess}
              onError={() => alert("Google login failed")}
              text="continue_with"
              shape="rectangular"
              width="278"
            />





            <p className="signup-text9090">
              Don't have an account?{" "}
              <span
                className="signup-link9090"
                onClick={() => setShowSignup(true)}
              >
                Free Signup
              </span>
            </p>
          </div>
        </div>
      )}

      {showSignup && <Signup onClose={() => setShowSignup(false)} />}
    </>
  );
};

export default LoginPopup;
